module.exports = __webpack_public_path__ + "img/vertical_3_7_7042.c7d4d1ae.png";